import queryString from 'query-string';
import imeAddendums from '../../molecules/addendums/addendums';

/**
 * Shows the Modal.
 *
 * @param {object} $modal jQuery modal object.
 */
function showModal( $modal ) {
	$modal.removeClass( 'visuallyhidden' );
	$( 'body' ).css( 'overflow', 'hidden' );
}

/**
 * Hides the Modal.
 *
 * @param {object} $modal jQuery modal object.
 */
function hideModal( $modal ) {
	$modal.addClass( 'visuallyhidden' );
	$( 'body' ).css( 'overflow', 'auto' );
}

/**
 * Opens the Modal when clicking on the buttons defined with the class `.open-modal-${modalId}`.
 *
 * @param {object} $modal jQuery modal object.
 */
function openModalWithClassButton( $modal ) {
	const modalId = $modal.attr( 'id' );
	const openModalButtons = document.querySelectorAll( `.open-modal-${modalId}` );

	if ( !openModalButtons.length ) {
		return;
	}

	const $document = $( document );

	Array.from( openModalButtons ).forEach( button => button.addEventListener( 'click', whenOpeningModal ) );

	/**
	 * Functions triggered when opening a modal.
	 */
	function whenOpeningModal() {
		showModal( $modal );
		fetchContent( $modal );
		// Activates the Escape Key listener to close the modal.
		closeModalOnEscapeKeyPress( $modal, $document );
	}
}

/**
 * Closes the Modal when clicking on the buttons defined with the class `.open-modal-${modalId}`.
 *
 * @param {object} $modal jQuery modal object.
 */
function closeModalWithClassButton( $modal ) {
	const modalId = $modal.attr( 'id' );
	const closeModalButtons = document.querySelectorAll( `.close-modal-${modalId}` );

	if ( !closeModalButtons ) {
		return;
	}

	Array.from( closeModalButtons ).forEach( button => button.addEventListener( 'click', () => hideModal( $modal ) ) );
}

/**
 * Closes the Modal when clicking the close icon.
 *
 * @param {object} $modal jQuery modal object.
 */
function closeModalOnIconClick( $modal ) {
	const $closeModalIcon = $modal.find( '.js-close-modal' );
	if ( !$closeModalIcon.length ) {
		return;
	}

	$closeModalIcon.on( 'click', () => closeModalAction( $modal ) );
}

/**
 * Hides the modal or redirects.
 *
 * @param {object} $modal jQuery modal object.
 */
function closeModalAction( $modal ) {
	const iconAction = $modal.data( 'on-close' );

	if ( iconAction ) {
		window.location = iconAction;
	} else {
		hideModal( $modal );
	}
}

/**
 * Closes the Modal when pressing the Escape key.
 *
 * @param {object} $modal jQuery modal object.
 * @param {object} $document jQuery document object.
 */
function closeModalOnEscapeKeyPress( $modal, $document ) {
	$document.on( 'keyup.hideMenuKey', function onPressEscapeKey( event ) {
		if ( typeof $modal.data('no-esc-close') === 'undefined' && event.keyCode === 27 ) {
			closeModalAction( $modal );
			$document.off( '.hideMenuKey' );
		}
	});
}

/**
 * Closes the Modal when pressing the escape key if the modal was opened on page load.
 *
 * @param {object} $modal jQuery modal object.
 */
function addInitialKeyPressListener( $modal ) {
	if ( !$modal.hasClass( 'visuallyhidden' ) ) {
		const $document = $( document );
		closeModalOnEscapeKeyPress( $modal, $document );
	}
}

/**
 * Opens Modal on document load when query param is set as the modal id.
 *
 * @param {object} $modal jQuery modal object.
 */
function openModalOnLoad( $modal ) {
	const parsed = queryString.parse( location.search );
	const modalId = $modal.attr( 'id' );
  const $header = $( '.o__header' );
  const sharedEntries = $header.attr( 'has-shared-entries' );
  const seeSharedEntriesText = 'See shared forms';
  const $buttons = $( '.modal-buttons' );

	if ( !jQuery.isEmptyObject( parsed ) && parsed.prompt === modalId ) {
		$modal.removeClass( 'visuallyhidden' );
		window.history.replaceState( null, null, window.location.pathname );
	}

  // Hide shared entries link if user hasn't shared entries.
  if ( sharedEntries ) {
    // Add small button class to modal buttons.
    $buttons.children().each( function addSmallBtnClass() {
      $( this ).addClass( 'a__btn--small' );
    });
  } else {
    $buttons.children().each( function hideSharedEntriesLink() {
      if ( $( this ).text().trim() === seeSharedEntriesText ) {
        $( this ).hide();
      }
    });
  }
}

/**
 * If 'ajax-endpoint' is defined then get the modal content from that value.
 *
 * @param {object} $modal jQuery modal object.
 */
function fetchContent( $modal ) {
	const url = $modal.data( 'ajax-endpoint' );
	if ( !url ) {
		return;
	}

	const $contentContainer = $modal.find( '.js-modal-content' );
	$contentContainer.addClass( 'loading' );

	$.ajax({
		url: `${window.mce.api_url}${url}`,
		cache: false,
		success: function( response ) {
			$contentContainer.removeClass( 'loading' );
			$contentContainer.html( response );
			if ( $modal.is( '[class*=addendum]' ) ) {
				// enable edit addendums on modal
				imeAddendums();
			}
		}
	});
}

/**
 * Modal functionnality
 *
 * it uses specific classes to open and closing a specific modal.
 * .open-modal-${modalId} => to open
 * .close-modal-${modalId} => to close
 */
export function modals() {
	const $modals = $( '.js-modal' );

	$.each( $modals, function setModals() {
		const $modal = $( this );
		openModalWithClassButton( $modal );
		closeModalWithClassButton( $modal );
		closeModalOnIconClick( $modal );
		openModalOnLoad( $modal );
		addInitialKeyPressListener( $modal );
	});
}
